module.exports = __webpack_public_path__ + "img/IMG_2592-2.a4d636b9.jpg";